module.exports = __webpack_public_path__ + "img/banner-bta.c4f04040.png";